import * as React from "react"

function ResultsSvgComponent (props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={80.371}
      height={40}
      viewBox="0 0 50.371 39.129"
      {...props}
    >
      <g data-name="Group 1674" fill="#b5b5c3" stroke="#fff">
        <path
          data-name="Path 26250"
          d="M25.2 38.629H4.328a3.531 3.531 0 01-3.678-2.6 4.558 4.558 0 01-.151-1.193q-.01-15.276 0-30.552A3.554 3.554 0 014.294.507q20.9-.005 41.8 0a3.56 3.56 0 013.781 3.794q.005 15.276 0 30.552a3.555 3.555 0 01-3.795 3.778q-10.444.005-20.88-.002zm-.045-2.235h20.819c1.169 0 1.629-.455 1.63-1.617V4.384c0-1.2-.452-1.644-1.656-1.644H4.416c-1.2 0-1.656.45-1.656 1.643v30.341c0 1.228.448 1.671 1.683 1.671z"
        />
        <path
          data-name="Path 26251"
          d="M25.181 9.471h-18.6c-.175 0-.351.01-.525-.007a1.132 1.132 0 01-1.057-1.159 1.086 1.086 0 011.088-1.061c.875-.024 1.752-.015 2.627-.015h35.1c.175 0 .351 0 .525.011a1.11 1.11 0 011.031 1.067 1.132 1.132 0 01-.957 1.143 2.7 2.7 0 01-.42.015z"
        />
        <path
          data-name="Path 26252"
          d="M11.667 31.897c-1.05 0-2.1.007-3.149 0a1.14 1.14 0 01-1.288-1.3q-.016-2.047 0-4.095a1.172 1.172 0 011.32-1.333q3.176-.014 6.351 0a1.16 1.16 0 011.313 1.286q.021 2.074 0 4.147a1.141 1.141 0 01-1.294 1.292c-1.084.01-2.169.003-3.253.003zm2.264-4.433H9.523v2.157h4.408z"
        />
        <path
          data-name="Path 26253"
          d="M11.724 16.199h3.2a1.145 1.145 0 011.285 1.253q.024 2.1 0 4.2a1.155 1.155 0 01-1.318 1.275q-3.176.007-6.353 0a1.156 1.156 0 01-1.313-1.28q-.02-2.074 0-4.148c.008-.887.442-1.3 1.344-1.3 1.055-.004 2.105 0 3.155 0zm-2.2 4.458h4.4v-2.19h-4.4z"
        />
        <path
          data-name="Path 26254"
          d="M25.223 16.197h3.15a1.156 1.156 0 011.3 1.292q.019 2.074 0 4.149a1.156 1.156 0 01-1.3 1.29q-3.2.009-6.406 0a1.144 1.144 0 01-1.274-1.266q-.021-2.1 0-4.2a1.142 1.142 0 011.276-1.263c1.085-.007 2.17 0 3.256 0zm2.154 4.466v-2.2h-4.4v2.2z"
        />
        <path
          data-name="Path 26255"
          d="M38.684 16.2h3.15a1.156 1.156 0 011.3 1.291q.02 2.048 0 4.1c-.008.925-.433 1.341-1.359 1.343q-3.176.007-6.353 0a1.141 1.141 0 01-1.274-1.265q-.022-2.1 0-4.2a1.141 1.141 0 011.277-1.262c1.089-.013 2.174-.007 3.259-.007zm-2.243 4.432h4.4v-2.164h-4.4z"
        />
        <path
          data-name="Path 26256"
          d="M11.693 13.967c-1.067 0-2.135.015-3.2 0a1.126 1.126 0 01-1.187-1.487 1.105 1.105 0 011.136-.765c2.187-.009 4.375-.017 6.562 0a1.128 1.128 0 110 2.25c-1.105.012-2.211.002-3.311.002z"
        />
        <path
          data-name="Path 26257"
          d="M25.131 13.968c-1.05 0-2.1.009-3.15 0a1.158 1.158 0 01-1.283-1.1 1.105 1.105 0 011.123-1.145q3.36-.035 6.72 0a1.107 1.107 0 011.127 1.136 1.127 1.127 0 01-1.177 1.1c-1.12.023-2.24.006-3.36.006z"
        />
        <path
          data-name="Path 26258"
          d="M38.65 11.7c1.085 0 2.17-.015 3.255 0a1.119 1.119 0 011.161 1.466 1.062 1.062 0 01-1.067.782c-2.24.015-4.48.021-6.72 0a1.109 1.109 0 01-1.121-1.149 1.127 1.127 0 011.184-1.09c1.1-.022 2.2-.006 3.307-.006z"
        />
        <path
          data-name="Path 26259"
          d="M25.238 25.163c1.068 0 2.135-.015 3.2 0a1.12 1.12 0 011.167 1.461 1.059 1.059 0 01-1.063.786c-2.24.016-4.48.021-6.72 0a1.11 1.11 0 01-1.126-1.144 1.125 1.125 0 011.179-1.095c1.12-.023 2.24-.006 3.36-.006z"
        />
        <path
          data-name="Path 26260"
          d="M38.654 27.431h-2.992a2.98 2.98 0 01-.625-.054 1.1 1.1 0 01.028-2.165 3.266 3.266 0 01.626-.043h6.036c.876.009 1.411.446 1.4 1.145-.011.683-.531 1.11-1.377 1.115-1.032.006-2.065 0-3.1 0z"
        />
        <path
          data-name="Path 26261"
          d="M38.645 31.898c-1.068 0-2.136.006-3.2 0a1.127 1.127 0 110-2.231q3.2-.006 6.408 0a1.128 1.128 0 110 2.235c-1.068.009-2.136 0-3.2 0z"
        />
        <path
          data-name="Path 26262"
          d="M25.184 31.901c-1.068 0-2.135.006-3.2 0a1.128 1.128 0 110-2.235q3.2-.007 6.4 0a1.126 1.126 0 110 2.231c-1.067.008-2.135 0-3.2 0z"
        />
      </g>
    </svg>
  )
}

export default ResultsSvgComponent
